import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetDormakabaConnectionRequest = {
  buildingId: number
}

export const getDormakabaConnectionQueryKey = (data: GetDormakabaConnectionRequest) => [
  'useGetDormakabaConnection',
  data,
]

// Note: response shape isn't documented anywhere we could verify (no GET schema available
// from Swagger at the time this was written) — used purely as a connected/not-connected
// probe, same as the legacy Swiftlane pattern. The response body is intentionally unused;
// do not add field pre-fill here without confirming the real shape with Backend first.
const getDormakabaConnection = async (data: GetDormakabaConnectionRequest) => {
  const response = await authAPI.get(`/dormakaba/integration/${data.buildingId}`)
  return response.data
}

export const useGetDormakabaConnection = (data: GetDormakabaConnectionRequest) =>
  useQuery({
    enabled: Boolean(data.buildingId),
    queryFn: () => getDormakabaConnection(data),
    queryKey: getDormakabaConnectionQueryKey(data),
  })
